'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _wrap = require('./wrap');

var _wrap2 = _interopRequireDefault(_wrap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function omit(predicate, collection) {
  return (0, _omit3.default)(collection, predicate);
}

exports.default = (0, _wrap2.default)(omit);


//////////////////
// WEBPACK FOOTER
// ./~/updeep/dist/omit.js
// module id = 1140
// module chunks = 0